import { createTheme  } from '@material-ui/core/styles';

import lightBlue from '@material-ui/core/colors/lightBlue';
import pink from '@material-ui/core/colors/pink';

export const theme = createTheme({
  palette: {
    primary: {
      main: lightBlue[900],
    },
    secondary: {
      main: pink[100],
      contrast: pink[900]
    },
    grey: {
      main: '#687783',
      background: '#edf0f4',
    }
  },
  typography: {
    useNextVariants: true
  },
  spacing: 8
});

